module.exports = __webpack_public_path__ + "img/20190812162904QQ截图20190812022946.1f8f2a4a.png";